import { anonymous } from '@flowio/request';
import session from '@flowio/session';
import { memory } from '@flowio/storage';
import find from 'lodash/find';
import get from 'lodash/get';

import config from './config';
import { getFeature } from './features';
import featureName from './constants/features';
import log from './utilities/log';

function getFormatterFunction(formatters, country = '') {
  if (!formatters) {
    return undefined;
  }

  const foundFormatter = find(formatters, (formatter, key) =>
    country.toUpperCase() === key.toUpperCase(),
  );

  if (foundFormatter) {
    return foundFormatter;
  }

  return formatters.all;
}

function defaultFormatShippingMessage(minDate, maxDate) {
  const dateFormatOptions = {
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  };

  const minFormattedDate = new Date(minDate).toLocaleDateString(
    session.getLocale(),
    dateFormatOptions,
  );
  const maxFormattedDate = new Date(maxDate).toLocaleDateString(
    session.getLocale(),
    dateFormatOptions,
  );
  return `${minFormattedDate} - ${maxFormattedDate}`;
}

function isRestrictedCountry(currentCountry, restrictedCountries) {
  if (!restrictedCountries || !currentCountry) {
    return false;
  }

  return !!find(restrictedCountries, (country) => {
    if (!country) {
      return false;
    }

    return currentCountry.toUpperCase() === country.toUpperCase();
  });
}

function displayShippingWindow() {
  return getFeature(featureName.DISPLAY_PDP_SHIPPING).then((feature) => {
    if (!feature || !feature.value) {
      return Promise.resolve();
    }

    const settings = memory.get('shippingWindow');
    const country = session.getCountry();
    const restrictedCountries = get(settings, 'restrictedCountries');

    if (isRestrictedCountry(country, restrictedCountries)) {
      return Promise.resolve();
    }

    const formatter = getFormatterFunction(get(settings, 'formatters'), country) || defaultFormatShippingMessage;

    const shippingWindowEls = window.document.querySelectorAll('[flow-shipping-window]');

    if (shippingWindowEls.length) {
      const geo = session.getGeo();
      const organization = session.getOrganization();

      return new Promise((resolve) => {
        anonymous({
          url: `${config.API_BASE_URI}/${organization}/delivery-windows/summary?destination=${encodeURIComponent(geo.country)}`,
          method: 'GET',
        }, (status, response) => {
          if (status < 300 && status >= 200) {
            shippingWindowEls.forEach((shippingWindowElement) => {
              const formattedWindow = formatter(response.from, response.to);
              // eslint-disable-next-line no-param-reassign
              shippingWindowElement.innerHTML = formattedWindow;
            });
          } else {
            log(`Error fetching shipping windows: \n\n Status ${status}\n Response: ${response}`);
          }
          return resolve();
        });
      });
    }
    return Promise.resolve();
  });
}

module.exports = {
  displayShippingWindow,
};



// WEBPACK FOOTER //
// ./static/js/v0/shipping-window.js